// extracted by mini-css-extract-plugin
export default {"calendar_wrapper":"Fo","modify_order":"Go","modify_order_header":"Ho","product_details_form_wrapper":"Io","c_wrapper":"Jo","save_button":"Ko","title":"Lo","modify_order_title_wrapper":"Mo","note":"No","buttons_wrapper":"Oo"};
    if(module.hot) {
      // 1711717530532
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  